module.exports = __webpack_public_path__ + "img/logo_pin.11782ef0.svg";